import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Property, Value } from "@/Models/Eav";
import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import { Marker } from "react-mark.js";
import PropertyMultiValueRows from "./PropertyMultiValueRows";

interface PropertyRowProps {
    group: Property;
    prop: Value;
    pIdx: number;
    debouncedSearch: string;
    isOpen: boolean;
    onToggle: () => void;
}

const PropertyRow = ({ group, prop, pIdx, debouncedSearch, isOpen, onToggle }: PropertyRowProps) => {
    const hasMultiValues = !!prop.values && prop.values.length > 1;

    if (!hasMultiValues) {
        return (
            <div
                key={prop.attr.Name}
                className={clsx("flex px-4", {
                    "bg-slate-50 dark:bg-slate-800": pIdx % 2,
                })}
            >
                <div className="w-2/5 p-1 text-slate-500">
                    <Marker as="small" mark={debouncedSearch}>
                        {prop.attr.Name}
                    </Marker>
                </div>
                <div className="w-3/5 p-1">
                    <Marker as="small" mark={debouncedSearch}>
                        {prop.value}
                    </Marker>
                </div>
            </div>
        );
    }

    return (
        <Collapsible open={isOpen} onOpenChange={onToggle}>
            <CollapsibleTrigger asChild>
                <div
                    className={clsx("flex px-4 cursor-pointer", {
                        "bg-slate-50 dark:bg-slate-800": pIdx % 2,
                    })}
                >
                    <div className="w-2/5 p-1 text-slate-500">
                        <Marker as="small" mark={debouncedSearch}>
                            {prop.attr.Name}
                        </Marker>
                    </div>
                    <div className="w-3/5 p-1 flex items-center">
                        <Marker as="small" mark={debouncedSearch}>
                            <em>{prop.value}</em>
                        </Marker>
                        <ChevronRight
                            className={clsx(
                                "ml-auto h-4 w-4 shrink-0 transition-transform duration-200",
                                isOpen && "rotate-90"
                            )}
                        />
                    </div>
                </div>
            </CollapsibleTrigger>
            <CollapsibleContent>
                <PropertyMultiValueRows
                    prop={prop}
                    category={group.category}
                    pIdx={pIdx}
                    debouncedSearch={debouncedSearch}
                />
            </CollapsibleContent>
        </Collapsible>
    );
};

export default PropertyRow;
